import React, { FC } from 'react';
import { InfoView } from 'components/InfoView';
import { useTranslation } from 'services/localization';
import { BuildingImage } from './BuildingImage';

interface OwnProps {
  message: string;
}

const DownForMaintenanceView: FC<OwnProps> = ({ message }) => {
  const { translate } = useTranslation();
  return <InfoView title={translate(message)} hero={<BuildingImage />} />;
};

export default DownForMaintenanceView;
